export default __webpack_public_path__ + "static/media/users-dollar.cb7b47a6.svg";